import React from 'react';
import styles from './FormTextField.module.scss';
import {
    Checkbox,
    FormGroup,
    FormControlLabel,
    FormControl,
    IconButton,
} from '@material-ui/core';
import { Close, DragIndicator } from '@material-ui/icons';

interface FormMultiChoiceFieldProps {
    id: string;
    title: string;
    value: string[];
    label?: boolean;
    isRequired?: boolean;
    isDraggable?: boolean;
    isRemovable?: boolean;
    isEditable?: boolean;
    options: any[];
    onClick?: (_id: string) => void;
    onChange: (_key: string, _value: string[]) => void;
    onRemove?: (_key: string) => void;
};

const FormMultiChoiceField = ({
    id,
    title,
    value,
    label,
    isRequired = false,
    isDraggable = false,
    isRemovable = false,
    isEditable = false,
    options,
    onClick,
    onChange,
    onRemove,
}: FormMultiChoiceFieldProps) => {
    const [checked, setChecked] = React.useState<string[]>(value || []);

    const handleChange = (option: string) => {
        setChecked((prev) => {
            const result = prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option];
            onChange(id, result);
            return result;
        });
    };

    const clickHanlder = (event: React.MouseEvent<HTMLDivElement>) => {
        const target = event.target;
        if (target instanceof HTMLButtonElement || target instanceof SVGElement) {
            return;
        }
        isEditable && onClick && onClick(id);
    };

    return (
        <div className={styles.containerChoice}
            onClick={clickHanlder}
            style={{ cursor: isEditable && onClick ? "pointer" : "default" }}>
            <FormControl component="fieldset">
                <FormGroup>
                    {label &&
                        <div className={styles.choiceTitle}>
                            {title}
                            {isRequired && <span style={{ color: 'red' }}> *</span>}
                        </div>
                    }
                    {options.map((option) => (
                        <FormControlLabel
                            key={option}
                            control={
                                <Checkbox
                                    name={option}
                                    color="primary"
                                    style={{ marginLeft: "0.5rem" }}
                                    checked={checked.includes(option)}
                                    onChange={() => handleChange(option)}
                                />
                            }
                            label={option}
                        />
                    ))}
                </FormGroup>
            </FormControl>
            {(isDraggable || isRemovable) &&
                <div className={styles.actions}>
                    {isRemovable && onRemove &&
                        <IconButton onClick={() => onRemove(id)}>
                            <Close />
                        </IconButton>
                    }
                    {isDraggable &&
                        <IconButton>
                            <DragIndicator />
                        </IconButton>
                    }
                </div>
            }
        </div>
    );
};

export default FormMultiChoiceField;
